import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AdminPagination from '../Admin/Pagination';
import AdminResultsPerPageSelector from '../Admin/ResultsPerPageSelector';

class UploadsFooter extends PureComponent {
  render() {
    const {
      uploadsTotal,
      page,
      perPage,
      handleChangePage,
      handleChangePerPage,
    } = this.props;

    return (
      <div className="table-footer">
        <AdminResultsPerPageSelector
          perPage={perPage}
          handleChangePerPage={handleChangePerPage}
        />
        <AdminPagination
          total={uploadsTotal}
          page={page}
          perPage={perPage}
          handleChangePage={handleChangePage}
        />
      </div>
    );
  }
}

UploadsFooter.propTypes = {
  uploadsTotal: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  handleChangePerPage: PropTypes.func.isRequired,
};

export default UploadsFooter;
